import Figure from "~/components/figure"
import RenderCofabComponent from "~/renderCofabComponent"
import { range } from "lodash"
import CurveTiles from "./figures/weights3/curveTiles"

const BannerRadial = ({ data }) => {
  const activeLayer = data.filter(({ layer }) => layer === "mixed3b")[0]

  const size = 400
  return (
    <CurvesRadial
      {...activeLayer}
      size={size}
      fillOpacity={0.4}
      orientationType={"max"}
    />
  )
}

export default class Banner extends Component {
  state = {}

  render() {
    const iconWidth = 100
    const sectionWidth = 480
    let i = 0

    const Section = ({ icon, title, children }) => (
      <Surface
        marginY={7}
        background="white"
        boxShadow="2px 8px 30px -3px rgba(50,50,93,.1)"
        overflow="hidden"
        borderRadius={6}
        paddingY={20}
        width={sectionWidth}
        style={{ border: "1px solid rgba(0, 0, 0, 0.18)" }}
      >
        <Surface flexFlow="row">
          {icon && (
            <div style={{ width: iconWidth, height: iconWidth }}>{icon}</div>
          )}
          <Surface paddingX={20} alignSelf="center" width="100%">
            <Surface
              flexFlow="row"
              paddingBottom={10}
              justifyContent="space-between"
              alignItems="center"
            >
              <Text size={600} fontWeight="bold">
                {title}
              </Text>
              <Text size={600} opacity={0.7} fontWeight="bold">
                Section {++i}
              </Text>
            </Surface>

            <Surface>{children}</Surface>
          </Surface>
        </Surface>
      </Surface>
    )

    const sectionFontSize = 18

    return (
      <Figure>
        <Surface flexFlow="row" marginY={20} alignItems="center">
          <Surface marginX={40} position="relative">
            <Surface>
              <Section title="Upstream Circuit" icon={null}>
                <Text lineHeight={1.5} fontSize={sectionFontSize}>
                  The group convolution motif connecting 3a with 3b
                </Text>
              </Section>
              <Section title="Downstream Circuit" icon={null}>
                <Text lineHeight={1.5} fontSize={sectionFontSize}>
                  Visualizing how curves are used with hue-mapping
                </Text>
              </Section>
              <Section title="Model Comparison" icon={null}>
                <Text lineHeight={1.5} fontSize={sectionFontSize}>
                  How universal are curve circuits?
                </Text>
              </Section>
            </Surface>
          </Surface>
          <Surface marginLeft={58} alignItems="center">
            <Surface
              zIndex={10}
              boxShadow="-5px 8px 40px -12px rgba(50,50,93,.4)"
              borderRadius={5}
            >
              <CurveTiles size={40} />
            </Surface>
            <Text marginTop={20} fontStyle="italic" size={500}>
              The weights connecting the curves in 3a and 3b approximate group
              convolution
            </Text>
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
